<template>
  <div>
    <a href="#"><span class="c-blue-text tw-underline" @click="dialog = true">EDIT QUOTE</span></a>
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card class="tw-py-3 md:tw-py-8">
        <v-card-text>
          <h3 class="tw-text-xl md:tw-text-xl c-blue-text title-font tw-text-center tw-pb-4 md:tw-pb-8">Additional Benefit Details</h3>
          <div class="tw-flex tw-justify-center">
            <v-card class="mx-auto tw-py-2 md:tw-py-3" outlined>
              <Outpatient choice="outpatient" @toggle-outpatient-addons="toggleAddons"/>
              <transition
                  name="fade"
                  mode="out-in"
                  appear
                  :duration="500"
              >
                <div v-if="showOutpatientAddOns">
                  <div class="tw-px-2 md:tw-px-8 tw-py-3 md:tw-py-6">
                    <h2 class="c-navy-text tw-font-bold">Customise your outpatient  Optional Covers</h2>
                  </div>
                  <div class="tw-px-4 md:tw-px-10 tw-py-3 md:tw-py-3">
                    <Dental :is-checked="$store.getters['rfq/getHealthQuote'].dental_limit" />
                  </div>
                  <div class="tw-px-4 md:tw-px-10 tw-py-3 md:tw-py-3">
                    <Optical :is-checked="$store.getters['rfq/getHealthQuote'].optical_limit" />
                  </div>
                </div>
              </transition>
            </v-card>
          </div>
          <div class="tw-flex tw-justify-center tw-mt-5">
            <v-btn color="secondary" @click="proceed">Save Details</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Outpatient from '@/components/rfq/health/components/Outpatient';
import Dental from '@/components/rfq/health/components/Dental';
import Optical from '@/components/rfq/health/components/Optical';

export default {
  name: 'OutpatientEdit',
  components: { Optical, Dental, Outpatient },
  data() {
    return {
      dialog: false,
      showOutpatientAddOns: true,
    };
  },
  methods: {
    proceed() {
      this.$root.$emit('health-edit-modal-closed');
      this.dialog = false;
    },
    toggleAddons(val) {
      this.showOutpatientAddOns = val;
    },
  },
};
</script>
